<template>

	<transition
		enter-active-class="transition-all duration-3s timing-ease"
		leave-active-class="transition-all duration-3s timing-ease"
		enter-class="opacity-0"
		enter-to-class="opacity-100"
		leave-class="opacity-100"
		leave-to-class="opacity-0"
		@after-enter="showContent = true"
		@before-leave="showContent = false"
	>

		<div class="fixed inset-0 flex items-center justify-center" style="background-color:rgba(255,255,255,.5); z-index:9999999;" @click.self="$emit('close')" v-if="visible">

			<transition
				enter-active-class="transition-transform duration-3s timing-ease"
				leave-active-class="transition-transform duration-3s timing-ease"
				enter-class="translate-y-100 opacity-0"
				enter-to-class="translate-y-0 opacity-100"
				leave-class="translate-y-0 opacity-100"
				leave-to-class="translate-y-100 opacity-0"
			>

				<div style="width:700px;max-width:80%" class="p-8 flex flex-col relative text-base bg-white shadow-lg" v-if="showContent">
					<div class="font-semibold text-xl sm:text-2xl leading-loose pb-4 border-b border-gray-400">{{ headline }}</div>
					<div class="py-4"><slot></slot></div>
					<div class="pt-4 border-t border-gray-400 text-right">
						<template v-if="buttons && buttons.length &gt; 0">
							<button v-for="(button, index) in buttons" :key="index" @click="button.action" class="button" :class="button.class">{{ button.text }}</button>
						</template>
						<template v-if="!hideButton">
							<button class="button" @click="$emit('close')">
								<span v-if="hideButtonText && hideButtonText != ''">{{ hideButtonText }}</span>
								<span v-else>Luk</span>
							</button>
						</template>
					</div>

				</div>

			</transition>

		</div>

	</transition>
</template>


<script>
export default {
	data() {
		return {
			showContent: false
		}
	},
	props: {
		visible: Boolean,
		headline: String,
		buttons: Array,
		hideButton: Boolean,
		hideButtonText: String
	}
}
</script>
